import { CHDataActionPayload, CHSuccessActionResult } from "@app/root-store/actions";
import { Action } from "@ngrx/store";
import { CHDataAction, CHDataSuccessAction, DataErrorAction } from "../../../shared/resources/data-actions";
import { DataServiceError } from "../../../shared/services/data-service-error";
import { CHServiceMetadata } from "../clarehome.state";

export enum ActionTypes {
    ClearServiceMetadata = "[Project Management] ClearServiceMetadata",
    GetServiceMetadata = "[Project Management] GetServiceMetadata",
    GetServiceMetadataSuccess = "[Project Management] GetServiceMetadataSuccess",
    GetServiceMetadataFailure = "[Project Management] GetServiceMetadataFailure",
}

export type ServiceMetadataResultPayload = CHSuccessActionResult<CHServiceMetadata>;
type ServiceMetadataPayload = CHDataActionPayload;
type ServiceMetadataAction = CHDataAction<CHServiceMetadata>;
type ServiceMetadataSuccessAction = CHDataSuccessAction<CHServiceMetadata>;
type ServiceMetadataFailureAction = DataErrorAction<ServiceMetadataResultPayload>;
type ServiceMetadataError = DataServiceError<ServiceMetadataResultPayload>;

export class ClearServiceMetadata implements Action {
    readonly type = ActionTypes.ClearServiceMetadata;
}

export class GetServiceMetadata implements ServiceMetadataAction {
    readonly type = ActionTypes.GetServiceMetadata;
    constructor(public readonly payload: ServiceMetadataPayload) {}
}

export class GetServiceMetadataSuccess implements ServiceMetadataSuccessAction {
    readonly type = ActionTypes.GetServiceMetadataSuccess;
    constructor(public readonly result: ServiceMetadataResultPayload) {}
}

export class GetServiceMetadataFailure implements ServiceMetadataFailureAction {
    readonly type = ActionTypes.GetServiceMetadataFailure;
    constructor(public readonly error: ServiceMetadataError) {}
}

export type Actions = ClearServiceMetadata | GetServiceMetadata | GetServiceMetadataSuccess | GetServiceMetadataFailure;
